/**
 * Seeds `shop-auth-status` on the client when an OIDC cookie is present.
 * Guests keep the default `{ entra: false, shop: false }` without a request.
 */
export default defineNuxtPlugin({
  name: 'shop-auth-status',
  enforce: 'pre',
  async setup() {
    const { $locale } = useNuxtApp();

    if ($locale.value === 'zh-cn') {
      return;
    }

    await useShopAuth().syncStatus();
  }
});
